import { Box, Button, ButtonAppearance } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const HeadingStyled = styled(Box).attrs({ pb: { sm: '500' }, pt: { sm: '600' }, px: { sm: '500' } })`
  ${({ theme }) => css`
    background: ${theme.colors.grey[200]};
    border: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const FooterButtonStyled = styled(Button).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;
